document.addEventListener('click', function(e) {

  const header = e.target.closest('.accordion-header');
  if (!header) return;

  const item = header.closest('.accordion-item');
  const container = item.closest('.product-accordion');
  const items = container.querySelectorAll('.accordion-item');

  const isOpen = item.classList.contains('is-open');

  // Cerrar todos
  items.forEach(el => {
    el.classList.remove('is-open');
    const content = el.querySelector('.accordion-content');
    content.style.maxHeight = null;
  });

  if (!isOpen) {
    // Abrir el clicado
    item.classList.add('is-open');
    const content = item.querySelector('.accordion-content');
    content.style.maxHeight = content.scrollHeight + "px";
  } else {
    // Si intenta cerrar el último abierto → abrir el primero
    const first = container.querySelector('.accordion-item');
    first.classList.add('is-open');
    const content = first.querySelector('.accordion-content');
    content.style.maxHeight = content.scrollHeight + "px";
  }

});

// Abrir el primero al cargar
document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.product-accordion');

  accordions.forEach(container => {
    const first = container.querySelector('.accordion-item');
    if (!first) return;

    const content = first.querySelector('.accordion-content');
    first.classList.add('is-open');
    content.style.maxHeight = content.scrollHeight + "px";
  });
});